import { makeStyles } from '@material-ui/core'
import logo from 'img/logo.png'
import { MenuItem } from './MenuItem'
import {
  // AdminIcon,
  DistanceIcon,
  LogIcon,
  MountpointsIcon,
  PermissionsIcon,
  ServerIcon,
  SignoutIcon,
  UsersIcon,
} from '../icons'
import { useToken } from '../App'
// import AllInboxIcon from '@material-ui/icons/AllInbox'
import { useHistory } from 'react-router-dom'

export function AdminMenu() {
  const classes = useStyles()
  const history = useHistory()
  const { userRole, userId } = useToken()
  const isAdmin = userRole === 'admin'

  if (userRole === 'regular') {
    history.replace(`/user/${userId}`)

    return null
  }

  return (
    <>
      <img alt="raycaster" src={logo} className={classes.logo} />
      {/* {isAdmin && <MenuItem route="/admin-settings" icon={AdminIcon} />} */}
      <MenuItem route="/users" icon={UsersIcon} />
      {isAdmin && <MenuItem route="/mountpoints" icon={MountpointsIcon} />}
      {/*<MenuItem route="/rinex/new" icon={AllInboxIcon} />*/}
      {isAdmin && <MenuItem route="/permissions" icon={PermissionsIcon} />}
      <MenuItem route="/server" icon={ServerIcon} />
      <MenuItem route="/measurement" icon={DistanceIcon} />
      <MenuItem route="/logs" icon={LogIcon} />
      <MenuItem route="/auth/signout" icon={SignoutIcon} />
    </>
  )
}

const useStyles = makeStyles((theme) => ({
  logo: {
    margin: theme.spacing(0, 1.5),
    width: 24,
    height: 24,
    [theme.breakpoints.down(theme.spacing(51))]: {
      margin: theme.spacing(0),
    },
  },
}))
